import React, { Fragment } from "react";
import { useDispatch, useSelector } from 'react-redux'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import HelpIcon from '@mui/icons-material/Help';
import LogotipoComerCam from './img/logotipoComercam.svg'
import LogoMagueySVG from './img/menuLogo.svg';
import Modal from '@mui/material/Modal';
import { cerrarSesionAccion } from './redux/UsuarioDucks'
import ReactToPrint from 'react-to-print';
import { useReactToPrint } from "react-to-print";
import PanelGenerarNuevaGuia from "./components/UsuarioAgricola/Menu/PanelGenerarNuevaGuia";
//import PanelReporteExcel from "./components/UsuarioAgricola/Menu/PanelReporteExcel";
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  color: 'black',
  p: 4,
  color: 'black'
};
const { useState, useEffect, useRef } = React;

import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink
} from "react-router-dom";
//import MainContent from "./components/MainContent";
import PerfilUsuario from './components/App/PerfilUsuario'
import LoadingComponent from './components/App/LoadingComponent'
import Login from "./components/App/Login";
// import Formato1 from "./components/formatos/Formato1";
// import Formato2 from "./components/formatos/Formato2";
// import Formato3 from "./components/formatos/Formato3";
// import Formato4 from "./components/formatos/Formato4";
// import Formato5 from "./components/formatos/Formato5";


import MenuHamburguesaBebeficiario from "./components/App/MenuHamburguesaBebeficiario";
import MenuHamburguesaInspeccion from "./components/App/MenuHamburguesaInspeccion";
import MenuHamburguesaDivisionAgricola2 from "./components/App/MenuHamburguesaDivisionAgricola2";


//----------Usuario Admin
import UsuariosComponent from './components/UsuarioAdmin/UsuariosComponent'

//----------Usuario Beneficiario
import NavBar from "./components/UsuarioBeneficiario/MainComponents/NavBar";
import SolicitudesMain from './components/UsuarioBeneficiario/MainComponents/SolicitudesMain'
import SolicitudDetalle from './components/UsuarioBeneficiario/MainComponents/SolicitudDetalle'
import FC_01Component from './components/UsuarioBeneficiario/FormularioFC01/FormularioFC01BeneficiarioComponent'
import FC_01AnexoAlmacenComponent from "./components/UsuarioBeneficiario/FormularioFC01/FormularioFC01AnexoAlmacenBeneficiarioComponent";
import FC_01AnexoEnvasadoComponent from "./components/UsuarioBeneficiario/FormularioFC01/FormularioFC01AnexoEnvasadoBeneficiarioComponent";
import FC_01AnexoProduccionComponent from "./components/UsuarioBeneficiario/FormularioFC01/FormularioFC01AnexoProduccionBeneficiarioComponent";
import FC_05Component from './components/UsuarioBeneficiario/FormularioFC05/FormularioFC05BeneficiarioComponent'
import FC_06Component from "./components/UsuarioBeneficiario/FormularioFC06/FormularioFC06BeneficiarioComponent";
import FC_08Component from './components/UsuarioBeneficiario/FormularioFC08/FormularioFC08BeneficiarioComponent'
import FC_09Component from './components/UsuarioBeneficiario/FormularioFC09/FormularioFC09BeneficiarioComponent'
import FC_30Component from "./components/UsuarioBeneficiario/FormularioFC30/FormularioFC30BeneficiarioComponent";
import FC_31Component from "./components/UsuarioBeneficiario/FormularioFC31/FormularioFC31BeneficiarioComponent";
import FC_33Component from './components/UsuarioBeneficiario/FormularioFC33/FormularioFC33BeneficiarioComponent';
import FC_34Component from "./components/UsuarioBeneficiario/FormularioFC34/FormularioFC34BeneficiarioComponent";
import FC_35Component from './components/UsuarioBeneficiario/FormularioFC35/FormularioFC35BeneficiarioComponent';
import FC_36Component from "./components/UsuarioBeneficiario/FormularioFC36/FormularioFC36BeneficiarioComponent";
import FC_36AnexoAlmacenComponent from "./components/UsuarioBeneficiario/FormularioFC36/FormularioFC36AnexoAlmacenBeneficiarioComponent";
import FC_36AnexoEnvasadoComponent from "./components/UsuarioBeneficiario/FormularioFC36/FormularioFC36AnexoEnvasadoBeneficiarioComponent";
import FC_36AnexoProduccionComponent from "./components/UsuarioBeneficiario/FormularioFC36/FormularioFC36AnexoProduccionBeneficiarioComponent";
import FC_40Component from "./components/UsuarioBeneficiario/FormularioFC40/FormularioFC40BeneficiarioComponent";
import FC_41Component from "./components/UsuarioBeneficiario/FormularioFC41/FormularioFC41BeneficiarioComponent";
import DocumentacionFC_01Component from "./components/UsuarioBeneficiario/FormularioFC01/DocumentacionFC_01Component";
import CertificadosBeneficiarioComponent from "./components/UsuarioBeneficiario/PanelCertificados/CertificadosBeneficiarioComponent";

//----------Usuario Atencion a Clientes 
//import FC_01Component from './components/UsuarioAtencionACliente/FormularioFC01/FC_01Component'

import NavBarAtencionACliente from "./components/UsuarioAtencionACliente/MainComponents/NavBarAtencionACliente";
import AtencionAClientesComponent from './components/UsuarioAtencionACliente/AtencionAClientesComponent'
import RevicionAtencionAClientesComponent from "./components/UsuarioAtencionACliente/RevicionAtencionAClienteComponent";
import FC_01AtencionAClientesComponent from "./components/UsuarioAtencionACliente/FormularioFC01/FC_01AtencionAClientesComponent";

import AtencionAClientesFC_01Component from './components/UsuarioAtencionACliente/FormularioFC01/AtencionAClientesFC_01Component'

import AtencionAClientesFC_01AnexoAlmacenComponent from "./components/UsuarioAtencionACliente/FormularioFC01/Anexos/AtencionAClientesFC_01AnexoAlmacenComponent";
import AtencionAClientesFC_01AnexoEnvasadoComponent from "./components/UsuarioAtencionACliente/FormularioFC01/Anexos/AtencionAClientesFC_01AnexoEnvasadoComponent";
import AtencionAClientesFC_01AnexoProduccionComponent from "./components/UsuarioAtencionACliente/FormularioFC01/Anexos/AtencionAClientesFC_01AnexoProduccionComponent";
import AtencionAClientesFC_05Component from './components/UsuarioAtencionACliente/FormularioFC05/AtencionAClientesFC_05Component'
import AtencionAClientesFC_06Component from "./components/UsuarioAtencionACliente/FormularioFC06/AtencionAClientesFC_06Component";
import AtencionAClientesFC_08Component from './components/UsuarioAtencionACliente/FormularioFC08/AtencionAClientesFC_08Component'
import AtencionAClientesFC_09Component from './components/UsuarioAtencionACliente/FormularioFC09/AtencionAClientesFC_09Component'
import AtencionAClientesFC_30Component from "./components/UsuarioAtencionACliente/FormularioFC30/AtencionAClientesFC_30Component";
import AtencionAClientesFC_31Component from "./components/UsuarioAtencionACliente/FormularioFC31/AtencionAClientesFC_31Component";
import AtencionAClientesFC_33Component from './components/UsuarioAtencionACliente/FormularioFC33/AtencionAClientesFC_33Component';
import AtencionAClientesFC_34Component from "./components/UsuarioAtencionACliente/FormularioFC34/AtencionAClientesFC_34Component";
import AtencionAClientesFC_35Component from './components/UsuarioAtencionACliente/FormularioFC35/AtencionAClientesFC_35Component';
import AtencionAClientesFC_36Component from "./components/UsuarioAtencionACliente/FormularioFC36/AtencionAClientesFC_36Component";
import AtencionAClientesFC_36AnexoAlmacenComponent from "./components/UsuarioAtencionACliente/FormularioFC36/Anexos/AtencionAClientesFC_36AnexoAlmacenComponent";
import AtencionAClientesFC_36AnexoEnvasadoComponent from "./components/UsuarioAtencionACliente/FormularioFC36/Anexos/AtencionAClientesFC_36AnexoEnvasadoComponent";
import AtencionAClientesFC_36AnexoProduccionComponent from "./components/UsuarioAtencionACliente/FormularioFC36/Anexos/AtencionAClientesFC_36AnexoProduccionComponent";
import AtencionAClientesFC_40Component from "./components/UsuarioAtencionACliente/FormularioFC40/AtencionAClientesFC_40Component";
import AtencionAClientesFC_41Component from "./components/UsuarioAtencionACliente/FormularioFC41/AtencionAClientesFC_41Component";
import Notificaciones from './components/App/Notificaciones'
import SesionExpirada from './components/App/SesionExpirada'
import PanelAtencionACliente from './components/UsuarioAtencionACliente/MainComponents/PanelAtencionACliente'
import PanelConsultaHologramasComponent from "./components/UsuarioAtencionACliente/PanelEntregas/PanelConsultaHologramasComponent";
import PanelDictamenesComponent from "./components/UsuarioAtencionACliente/DictamenFiscalJuridicoMarcario/PanelDetalleCliente/PanelDictamenesComponent";
import SolicitudesDictamenesComponent from "./components/UsuarioAtencionACliente/DictamenFiscalJuridicoMarcario/SolicitudesDictamenesComponent";

//----------Usuario Inspector
import PanelCalendario from './components/UsuarioInspector/PanelCalendario'
import PanelVisitasFormComponent from './components/UsuarioInspector/PanelVisitasForm/PanelVisitasFormComponent'
import PanelAgenda from './components/UsuarioInspector/PanelAgenda'
import PanelAsociados from './components/UsuarioInspector/PanelAsociados'
import PanelAutorizacionEtiquetas from './components/UsuarioInspector/PanelAutorizacionEtiquetas'
import PanelEtiquetas from './components/UsuarioInspector/PanelEtiquetas'
import PanelFisicoQuimicos from './components/UsuarioInspector/PanelFisicoQuimicos'
import PanelInformes from './components/UsuarioInspector/PanelInformes'
import Panellnventario from './components/UsuarioInspector/Panellnventario'
import PanelTrazabilidad from './components/UsuarioInspector/PanelTrazabilidad'
import PanelVisitas from './components/UsuarioInspector/PanelVisitas'
import PanelCatalogoMaguey from './components/UsuarioInspector/PanelCatalogoMaguey'
import PanelInspectores from './components/UsuarioInspector/PanelInspectores'
import PanelZonas from './components/UsuarioInspector/PanelZonas'
import PanelSolicitudes from './components/UsuarioInspector/PanelSolicitudes'
import PanelBenficiarios from './components/UsuarioAtencionACliente/PanelUsuariosBeneficiarios/UsuariosBeneficiariosComponent'

import LocalidadesDeLaZona from "./components/UsuarioInspector/Zonas/LocalidadesDeLaZonaComponent";//


//----------Usuario InspectorDeCampo
import MenuHamburguesaInspectorDeCampo from "./components/App/MenuHamburguesaInspectorDeCampo";
import PanelAsociadosComponent from "./components/UsuarioInspectorEnCampo/PanelAsociadosComponent";
import PanelInspeccionComponent from "./components/UsuarioInspectorEnCampo/PanelInspeccionComponent";


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning,
  faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning,
  faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark)

import 'react-notifications-component/dist/theme.css'
import FormularioDocumentacion from "./components/formatos/FormularioDocumentacion";
import PanelRegistoPredio from "./components/UsuarioAgricola/Menu/PanelRegistoPredio";
import PanelConstancia from "./components/UsuarioAgricola/Menu/PanelConstancia";
import Constancia from "./components/UsuarioAgricola/Menu/Constancias/Constancia";
import Predio_Descuento_Guia from "./components/UsuarioAgricola/Predio/Predio_Descuento_Guia";
import Descuento_Predio from "./components/UsuarioAgricola/Predio/Descuento_Predio";
import PanelReporteExcel from "./components/UsuarioAgricola/Menu/PanelReporteExcel";
import PanelBuscarAsociado from "./components/UsuarioAgricola/PanelBuscarAsociado";
import DatosPredio from "./components/UsuarioAgricola/Predio/DatosPredio";
import PanelConsultarGuia from "./components/UsuarioAgricola/Predio/PanelConsultarGuia";
import PanelEditarMaguey from "./components/UsuarioAgricola/Predio/PanelEditarMaguey";
import PanelConsultaMovimiento from "./components/UsuarioAgricola/PanelConsultaMovimiento";
import PanelInformacionPredio from "./components/UsuarioAgricola/Predio/PanelInformacionPredio";
import UsuariosAuxiliaresAgricolaComponent from "./components/UsuarioAgricola/PanelUsuariosAuxiliaresAgricola/UsuariosAuxiliaresAgricolaComponent";

import DocumentacionFC_09Component from "./components/UsuarioBeneficiario/FormularioFC09/DocumentacionFC_09Component";
import DocumentacionFC_33Component from "./components/UsuarioBeneficiario/FormularioFC33/DocumentacionFC_33Component";
import DocumentacionFC_30Component from "./components/UsuarioBeneficiario/FormularioFC30/DocumentacionFC_30Component";
import DocumentacionFC_05Component from "./components/UsuarioBeneficiario/FormularioFC05/DocumentacionFC_05Component";
import DocumentacionFC_35Component from "./components/UsuarioBeneficiario/FormularioFC35/DocumentacionFC_35Component";
import DocumentacionFC_06Component from "./components/UsuarioBeneficiario/FormularioFC06/DocumentacionFC_06Component";
import DocumentacionFC_08Component from "./components/UsuarioBeneficiario/FormularioFC08/DocumentacionFC_08Component";
import DocumentacionFC_40Component from "./components/UsuarioBeneficiario/FormularioFC40/DocumentacionFC_40Component";
import DocumentacionFC_41Component from "./components/UsuarioBeneficiario/FormularioFC41/DocumentacionFC_41Component";
import DocumentacionFC_31Component from "./components/UsuarioBeneficiario/FormularioFC31/DocumentacionFC_31Component";
import DocumentacionFC_36Component from "./components/UsuarioBeneficiario/FormularioFC36/DocumentacionFC_36Component";
import PanelConsulta from './components/UsuarioAtencionACliente/ModuloConsulta/TablaClientesComponent'
import DetalleCliente from './components/UsuarioAtencionACliente/ModuloConsulta/DetalleClienteComponent'
import PanelVehiculos from "./components/UsuarioInspector/PanelVehiculos";
import VisualizadorPdfComponent from "./components/UsuarioInspectorEnCampo/Asociados/PDF/VisualizadorPdfComponent";

import ModalReutilizableComponent from "./components/App/ModalReutilizableComponent";

/** Datos para organismo de certificacion */
import SolicitudesOrganismoComponent from "./components/UsuarioOrganismoCertificacion/UsuarioNacional/SolicitudesOrganismoComponent";
import MenuHamburguesaCertificado from "./components/UsuarioOrganismoCertificacion/UsuarioNacional/MainOrganismoComponents/MenuHamburguesaCertificado";
import MenuHamburguesaExportacion from "./components/UsuarioOrganismoCertificacion/UsuarioExportacion/MainOrganismoComponents/MenuHamburguesaExportacion";
import InformacionClienteComponent from "./components/UsuarioOrganismoCertificacion/UsuarioNacional/FC_01/InformacionCliente/InformacionClienteComponent";
import UsuariosOCNacionalComponent from "./components/UsuarioOrganismoCertificacion/UsuarioNacional/PanelUsuariosNacionalOC/UsuariosOCNacionalComponent";
import UsuariosOCExportacionComponent from "./components/UsuarioOrganismoCertificacion/UsuarioExportacion/PanelUsuariosExportacionOC/UsuariosOCExportacionComponent";
import TablaClientesComponentOC from "./components/UsuarioOrganismoCertificacion/ModuloConsulta/TablaClientesComponent"
import DetalleClienteComponent from "./components/UsuarioOrganismoCertificacion/ModuloConsulta/DetalleClienteComponent"
import TabsSolicitudesEstatusUIComponent from "./components/UsuarioOrganismoCertificacion/UsuarioNacional/SolicitudesEstatusUI/TabsSolicitudesEstatusUIComponent";
import SolicitudesAtendidasACComponent from "./components/UsuarioOrganismoCertificacion/UsuarioNacional/SolicitudesAtendidasACComponent";
import SolicitudesRevisionOCUIComponent from "./components/UsuarioOrganismoCertificacion/UsuarioNacional/SolicitudesRevisionOCUIComponent";
import SeguimientoComponent from "./components/UsuarioOrganismoCertificacion/UsuarioNacional/SeguimientoComponent";
import TabsSolicitudesAtendidasACComponent from "./components/UsuarioOrganismoCertificacion/UsuarioNacional/SolicitudesAtendidasAC/TabsSolicitudesAtendidasACComponent";
import TabsSolicitudesACExportacionComponent from "./components/UsuarioOrganismoCertificacion/UsuarioExportacion/SolicitudesAtendidasAC/TabsSolicitudesAtendidasACComponent";
//Datos para OC Exportacion
import SolicitudesRecibidasComponent from "./components/UsuarioOrganismoCertificacion/UsuarioExportacion/SolicitudesEstatusOC/SolicitudesRecibidasComponent";
import SolicitudesRevisionOCExportacion from "./components/UsuarioOrganismoCertificacion/UsuarioExportacion/SolicitudesEstatusOC/SolicitudesRevisionOCExportacionComponent";
import SeguimientoExportacionComponent from "./components/UsuarioOrganismoCertificacion/UsuarioExportacion/SolicitudesEstatusOC/SeguimientoExportacionComponent";
import InformacionFC09_OCComponent from "./components/UsuarioOrganismoCertificacion/UsuarioExportacion/FC_09/InformacionFC09_OCComponent";



//Componentes para panel de hologramas 
import MenuHamburguesaHolograma from "./components/UsuarioHologramas/MenuHamburgesa/MenuHamburguesaHolograma";
import PanelComprasComponent from "./components/UsuarioHologramas/PanelCompras/PanelComprasComponent";
import PanelEntregasComponent from "./components/UsuarioHologramas/PanelEntregas/PanelEntregasComponent";
import PanelInventariosComponent from "./components/UsuarioHologramas/PanelInventarios/PanelInventariosComponent";
import DetalleDeCompraComponent from "./components/UsuarioHologramas/PanelCompras/DetalleSolicitudDeCompra/DetalleDeCompraComponent";
import DetalleDeEntregaComponent from "./components/UsuarioHologramas/PanelEntregas/DetalleSolicitudDeEntrega/DetalleDeEntregaComponent";
import PerfilUsuarioAgricola from "./components/UsuarioAgricola/Perfil/PerfilUsuarioAgricola";
import MenuHamburguesaAtencionCliente from "./components/App/MenuHamburguesaAtencionCliente";
import SolicitudesRevisionOCComponent from "./components/UsuarioOrganismoCertificacion/UsuarioNacional/SolicitudesRevisionOCUIComponent";

//Componenetes para direccion y gerente
import MenuHamburguesaDireccion from "./components/UsuarioDireccionGerente/MenuComponents/MenuHamburguesa";
import TablaClientesComponentDG from './components/UsuarioDireccionGerente/ModuloConsulta/TablaClientesComponent'
import DetalleClienteComponentDG from './components/UsuarioDireccionGerente/ModuloConsulta/DetalleClienteComponent'
import PanelConsultaHologramasDGComponent from "./components/UsuarioDireccionGerente/PanelHologramas/PanelConsultaHologramasDGComponent";
import SolicitudesACDireccion from "./components/UsuarioDireccionGerente/PanelAtencionClientes/TabsSolicitudesAtendidasACComponent";
import TabsOCNacionalDGComponent from "./components/UsuarioDireccionGerente/PanelOCNacional/TabsOCNacionalDGComponent";
import TabsUIDGComponent from "./components/UsuarioDireccionGerente/PanelUnidadInspeccion/TabsSolicitudesEstatusUIComponent";

function App() {

  const currentUser = useSelector(store => store.Usuario.data)
  const loginIn = localStorage.getItem('user')
  const id = useSelector(store => store.Usuario.tipoUsuario)

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  const drawerWidth = 300;
  const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: `-${drawerWidth}px`,
      ...(open && {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
      }),
    }),
  );

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  }));

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


  const dispatch = useDispatch()

  /******Modal */
  const [openModal, setOpenModal] = React.useState(false);
  const [titleModal, setTitleModal] = React.useState('');
  const [bodyModal, setBodyModal] = React.useState('')
  const [accion, setAccion] = React.useState('')

  const handleOpenModal = (data) => {
    setTitleModal(data.title)
    setBodyModal(data.body)
    setAccion(data.accion)
    setOpenModal(true)
  }
  const handleCloseModal = () => {
    setTitleModal('')
    setBodyModal('')
    setAccion('')
    setOpenModal(false)
  }
  const cerrarSesionModal = () => {
    handleOpenModal({
      title: `Advtertencia!`,
      body: `Está a punto de CERRAR SESIÓN, todos los cambios no guardados se perderán`,
      accion: 'cerrarSesion'
    })
  }

  const cerrarSesion = async () => {
    await dispatch(cerrarSesionAccion())
    window.location.reload(false);
    window.location.href = '/';
  }


  const agregarClasesToggle = () => {

    if (claseBodyPD === '' && claseNav === '' && claseBodyPD === '' && claseHeaderPD === '') {
      setclaseToggle('bx-x');
      setclaseNav('show');
      setclaseBodyPD('body-pd');
      setHeaderPD('body-pd');
      setOverFlowDinamico('scroll')
    }
    else {
      setclaseToggle('');
      setclaseNav('');
      setclaseBodyPD('');
      setHeaderPD('');
      setOverFlowDinamico('hidden')

    }
  }

  const usuario = useSelector(store => store.Usuario.data)

  const paddingContendorByUser = '5%';

  const modalComponent = () => {
    return (
      <div>
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <center>{titleModal}</center>
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: 'center' }}>
              {bodyModal} <br /> <strong>¿Desea continuar?</strong>
            </Typography>
            <br />
            <div className='row'>
              <button className='btn btn-success' onClick={() => {
                switch (accion) {
                  case 'cerrarSesion':
                    cerrarSesion()
                    break;
                  default:
                    break;
                }
              }
              }>CONTINUAR</button>
            </div>
          </Box>
        </Modal>
      </div>
    )
  }

  return (
    <Fragment >
      <Router>
        {
          id === undefined &&
          (
            <div className="h-100 container-fluid mt-3 bg-dark bg-gradient">
              <Login />
            </div>
          )
        }
        {
          currentUser || loginIn ? (

            <div style={{ backgroundColor: (id == 9 || id == 10) ? '#E3EFF1' : 'white', paddingLeft: id === 1 ? paddingContendorByUser : '0' }} >

              <LoadingComponent />
              <Notificaciones />
              <SesionExpirada />
              {/*BARRA DE ARRIBA */}


              <Fragment>
                {
                  id === 1 ? (
                    <Fragment>
                      {/*MENÚ DE HAMBURGUESA */}
                      <MenuHamburguesaBebeficiario cerrarSesionModal={cerrarSesionModal} agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()} idUsuario={id} />

                      {/*MENÚ DE OPCIONES PRINCIPAL */}
                      <br /><br></br>
                      <Switch>
                        <Route path="/perfil_usuario" component={PerfilUsuario} />
                        <Route path="/solicitudes" component={SolicitudesMain} />
                        <Route path='/solicitud_detalle' component={SolicitudDetalle} exact />
                        <Route path="/fc_01" component={FC_01Component} exact />
                        <Route path='/fc_01AnexoAlmacen' component={FC_01AnexoAlmacenComponent} exact />
                        <Route path='/fc_01AnexoEnvasado' component={FC_01AnexoEnvasadoComponent} exact />
                        <Route path='/fc_01AnexoProduccion' component={FC_01AnexoProduccionComponent} exact />
                        <Route path="/FC_01AnexoProduccionComponent" component={FC_01AnexoProduccionComponent} exact />
                        <Route path="/FC_01AnexoEnvasadoComponent" component={FC_01AnexoEnvasadoComponent} exact />
                        <Route path="/FC_01AnexoAlmacenComponent" component={FC_01AnexoAlmacenComponent} exact />
                        <Route path="/DocumentacionFC_01Component" component={DocumentacionFC_01Component} exact />
                        <Route path="/UsuariosComponent" component={UsuariosComponent} exact />
                      </Switch>
                    </Fragment>
                  ) :
                    id === 2 ?
                      (
                        <Fragment>
                          <MenuHamburguesaBebeficiario cerrarSesionModal={cerrarSesionModal} agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()} idUsuario={id} />
                          <br /><br></br>
                          <Switch>
                            <Route path="/perfil_usuario" component={PerfilUsuario} />
                            <Route path="/solicitudes" component={SolicitudesMain} />
                            <Route path='/solicitud_detalle' component={SolicitudDetalle} exact />
                            {/* <Route path="/fc_01" component={FC_01Component} exact />
                            <Route path='/fc_01AnexoAlmacen' component={FC_01AnexoAlmacenComponent} exact />
                            <Route path='/fc_01AnexoEnvasado' component={FC_01AnexoEnvasadoComponent} exact />
                            <Route path='/fc_01AnexoProduccion' component={FC_01AnexoProduccionComponent} exact /> */}
                            <Route path="/fc_05" component={FC_05Component} exact />
                            <Route path="/fc_08" component={FC_08Component} exact />
                            <Route path="/fc_09" component={FC_09Component} exact />
                            <Route path="/DocumentacionFC_09Component" component={DocumentacionFC_09Component} exact />
                            <Route path="/fc_33" component={FC_33Component} exact />
                            <Route path="/DocumentacionFC_33Component" component={DocumentacionFC_33Component} exact />
                            <Route path="/DocumentacionFC_30Component" component={DocumentacionFC_30Component} exact />
                            <Route path="/fc_35" component={FC_35Component} exact />
                            <Route path="/fc_34" component={FC_34Component} exact />
                            <Route path="/fc_06" component={FC_06Component} exact />
                            <Route path="/fc_30" component={FC_30Component} exact />
                            <Route path="/fc_31" component={FC_31Component} exact />
                            <Route path="/fc_40" component={FC_40Component} exact />
                            <Route path="/fc_41" component={FC_41Component} exact />
                            <Route path="/fc_36" component={FC_36Component} exact />
                            <Route path="/fc_36AnexoProduccion" component={FC_36AnexoProduccionComponent} exact />
                            <Route path="/fc_36AnexoAlmacen" component={FC_36AnexoAlmacenComponent} exact />
                            <Route path="/fc_36AnexoEnvasado" component={FC_36AnexoEnvasadoComponent} exact />
                            <Route path="/FC_01AnexoProduccionComponent" component={FC_01AnexoProduccionComponent} exact />
                            <Route path="/FC_01AnexoEnvasadoComponent" component={FC_01AnexoEnvasadoComponent} exact />
                            <Route path="/FC_01AnexoAlmacenComponent" component={FC_01AnexoAlmacenComponent} exact />
                            <Route path="/AtencionAClientesComponent" component={AtencionAClientesComponent} exact />
                            <Route path="/UsuariosComponent" component={UsuariosComponent} exact />
                            <Route path="/DocumentacionFC_05Component" component={DocumentacionFC_05Component} exact />
                            <Route path="/DocumentacionFC_35Component" component={DocumentacionFC_35Component} exact />
                            <Route path="/DocumentacionFC_06Component" component={DocumentacionFC_06Component} exact />
                            <Route path="/DocumentacionFC_08Component" component={DocumentacionFC_08Component} exact />
                            <Route path="/DocumentacionFC_40Component" component={DocumentacionFC_40Component} exact />
                            <Route path="/DocumentacionFC_41Component" component={DocumentacionFC_41Component} exact />
                            <Route path="/DocumentacionFC_31Component" component={DocumentacionFC_31Component} exact />
                            <Route path="/modal" component={ModalReutilizableComponent} exact />
                            <Route path="/DocumentacionFC_36Component" component={DocumentacionFC_36Component} exact />
                            <Route path="/CertificadosBeneficiarioComponent" component={CertificadosBeneficiarioComponent} exact />
                          </Switch>
                        </Fragment>
                      ) : id === 3 ?
                        (
                          <Fragment>
                            <MenuHamburguesaAtencionCliente cerrarSesionModal={cerrarSesionModal} agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()} idUsuario={id} />

                            <br /><br></br>
                            <Switch>
                              <Route path="/perfil_usuario" component={PerfilUsuario} />
                              <Route path="/AtencionAClientesComponent" component={AtencionAClientesComponent} exact />
                              {/* <Route path="/fc_01" component={AtencionAClientesFC_01Component} exact /> */}
                              {/* <Route path='/fc_01AnexoAlmacen' component={AtencionAClientesFC_01AnexoAlmacenComponent} exact />
                              <Route path='/fc_01AnexoEnvasado' component={AtencionAClientesFC_01AnexoEnvasadoComponent} exact />
                              <Route path='/fc_01AnexoProduccion' component={AtencionAClientesFC_01AnexoProduccionComponent} exact /> */}
                              <Route path="/fc_05" component={AtencionAClientesFC_05Component} exact />
                              <Route path="/fc_08" component={AtencionAClientesFC_08Component} exact />
                              <Route path="/fc_09" component={AtencionAClientesFC_09Component} exact />
                              <Route path="/fc_33" component={AtencionAClientesFC_33Component} exact />
                              <Route path="/fc_35" component={AtencionAClientesFC_35Component} exact />
                              <Route path="/fc_34" component={AtencionAClientesFC_34Component} exact />
                              <Route path="/fc_06" component={AtencionAClientesFC_06Component} exact />
                              <Route path="/fc_30" component={AtencionAClientesFC_30Component} exact />
                              <Route path="/fc_31" component={AtencionAClientesFC_31Component} exact />
                              <Route path="/fc_40" component={AtencionAClientesFC_40Component} exact />
                              <Route path="/fc_41" component={AtencionAClientesFC_41Component} exact />
                              <Route path="/fc_36" component={AtencionAClientesFC_36Component} exact />
                              <Route path="/fc_36AnexoProduccion" component={AtencionAClientesFC_36AnexoProduccionComponent} exact />
                              <Route path="/fc_36AnexoAlmacen" component={AtencionAClientesFC_36AnexoAlmacenComponent} exact />
                              <Route path="/fc_36AnexoEnvasado" component={AtencionAClientesFC_36AnexoEnvasadoComponent} exact />
                              <Route path="/RevicionAtencionAClientesComponent" component={RevicionAtencionAClientesComponent} exact />
                              <Route path="/FC_01AtencionAClientesComponent" component={FC_01AtencionAClientesComponent} exact />
                              <Route path="/PanelAtencionACliente" component={PanelAtencionACliente} exact />
                              <Route path="/PanelBenficiarios" component={PanelBenficiarios} exact />
                              <Route path="/PanelConsulta" component={PanelConsulta} exact />
                              <Route path="/DetalleCliente" component={DetalleCliente} exact />
                              <Route path="/PanelConsultaHologramasComponent" component={PanelConsultaHologramasComponent} exact />
                              <Route path="/PanelDictamenesComponent" component={PanelDictamenesComponent} exact />
                              <Route path="/SolicitudesDictamenesComponent" component={SolicitudesDictamenesComponent} exact />
                            </Switch>

                          </Fragment>
                        )
                        : id === 5 ?
                          (
                            <Fragment>
                              <MenuHamburguesaInspeccion cerrarSesionModal={cerrarSesionModal} agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()} idUsuario={id} />
                              <Switch>
                                <Route path='/PanelVisitas' component={PanelVisitas} exact />
                                <Route path="/PanelCalendario" component={PanelCalendario} exact />
                                <Route path="/PanelVisitasForm" component={PanelVisitasFormComponent} exact />
                                <Route path="/PanelInspectores" component={PanelInspectores} exact />
                                <Route path="/PanelZonas" component={PanelZonas} exact />
                                <Route path="/ZonasLocalidadesComponent" component={LocalidadesDeLaZona} exact />
                                <Route path="/PanelAsociados" component={PanelAsociados} exact />
                                <Route path="/PanelSolicitudes" component={PanelSolicitudes} exact />
                                <Route path="/PanelVehiculos" component={PanelVehiculos} exact />
                                <Route path="/PanelInspeccion" component={PanelInspeccionComponent} exact />
                                <Route path="/panelFisicoQuimicos" component={PanelFisicoQuimicos} exact />
                                <Route path="/panelTrazabilidad" component={PanelTrazabilidad} exact />
                              </Switch>
                            </Fragment>
                          )
                          : id === 6 ?
                            (
                              <Fragment>
                                <MenuHamburguesaDivisionAgricola2 cerrarSesionModal={cerrarSesionModal} agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()} idUsuario={id} />
                                <Switch>
                                  <Route path='/PanelConstancia' component={PanelConstancia} exact />
                                  <Route path='/Descuento_Guia' component={Predio_Descuento_Guia} exact />
                                  <Route path='/Descuento_Predio' component={Descuento_Predio} exact />
                                  <Route path='/PanelRegistroPredio' component={PanelRegistoPredio} exact />
                                  <Route path="/PanelGenerarNuevaGuia" component={PanelGenerarNuevaGuia} exact />
                                  <Route path="/PanelReporteExcel" component={PanelReporteExcel} exact />
                                  <Route path="/PanelBuscarAsociado" component={PanelBuscarAsociado} exact />
                                  <Route path="/DatosPredio" component={DatosPredio} exact />
                                  <Route path="/PanelConsultarGuia" component={PanelConsultarGuia} exact />
                                  <Route path="/PanelEditarMaguey" component={PanelEditarMaguey} exact />
                                  <Route path="/PanelConsultaMovimiento" component={PanelConsultaMovimiento} exact />
                                  <Route path="/PanelInformacionPredio" component={PanelInformacionPredio} exact />
                                  <Route path="/PerfilUsuarioAgricola" component={PerfilUsuarioAgricola} />
                                  <Route path="/UsuariosAuxiliaresAgricola" component={UsuariosAuxiliaresAgricolaComponent} />
                                </Switch>
                              </Fragment>
                            ) : id === 4 ?
                              (
                                <Fragment>
                                  <MenuHamburguesaInspectorDeCampo cerrarSesionModal={cerrarSesionModal} agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()} idUsuario={id} />
                                  <Switch>
                                    <Route path="/PanelAsociados" component={PanelAsociadosComponent} exact />
                                    <Route path="/PanelInspeccion" component={PanelInspeccionComponent} exact />
                                    <Route path="/Previsualizacion" component={VisualizadorPdfComponent} exact />
                                  </Switch>
                                </Fragment>
                              )
                              : id === 8 ?
                                <Fragment>
                                  <MenuHamburguesaCertificado cerrarSesionModal={cerrarSesionModal}
                                    agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()}
                                    idUsuario={id} />
                                  <Switch>
                                    <Route path="/SolicitudesOrganismoComponent" component={SolicitudesOrganismoComponent} exact />
                                    <Route path="/perfil_usuario" component={PerfilUsuario} />
                                    <Route path="/InformacionClienteComponent" component={InformacionClienteComponent} exact />
                                    <Route path="/UsuariosOCNacionalComponent" component={UsuariosOCNacionalComponent} exact />
                                    <Route path="/ModuloConsultaOCComponent" component={TablaClientesComponentOC} exact />
                                    <Route path="/ConsultaDetalleOCComponent" component={DetalleClienteComponent} exact />
                                    <Route path="/TabsSolicitudesEstatusUIComponent" component={TabsSolicitudesEstatusUIComponent} />
                                    <Route path="/TabsSolicitudesAtendidasACComponent" component={TabsSolicitudesAtendidasACComponent} />
                                    <Route path="/SolicitudesAtendidasACComponent" component={SolicitudesAtendidasACComponent} />
                                    <Route path="/SolicitudesRevisionOCUIComponent" component={SolicitudesRevisionOCUIComponent} />
                                    <Route path="/SeguimientoComponent" component={SeguimientoComponent} />
                                    <Route path="/FC27" component={FC27Component}></Route>
                                    <Route path="/PanelFC13" component={FC13Component}></Route>
                                    <Route path="/SolicitudesEstatusComponent" component={SolicitudesEstatusComponent} exact />
                                    <Route path="/InformacionClienteComponent" component={InformacionClienteComponent} exact />
                                  </Switch>
                                </Fragment>
                                : id === 9 ?
                                  <Fragment>
                                    <MenuHamburguesaHolograma cerrarSesionModal={cerrarSesionModal}
                                      agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()}
                                      idUsuario={id} />
                                    <Switch>
                                      <Route path="/PanelComprasComponent" component={PanelComprasComponent} />
                                      <Route path="/PanelEntregasComponent" component={PanelEntregasComponent} />
                                      <Route path="/PanelInventariosComponent" component={PanelInventariosComponent} />
                                      <Route path="/DetalleDeCompraComponent" component={DetalleDeCompraComponent} />
                                      <Route path="/DetalleDeEntregaComponent" component={DetalleDeEntregaComponent} />
                                    </Switch>
                                  </Fragment>
                                  : id === 10 ?
                                    <Fragment>
                                      <MenuHamburguesaHolograma cerrarSesionModal={cerrarSesionModal}
                                        agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()}
                                        idUsuario={id} />
                                      <Switch>
                                        <Route path="/PanelComprasComponent" component={PanelComprasComponent} />
                                        <Route path="/DetalleDeCompraComponent" component={DetalleDeCompraComponent} />
                                      </Switch>
                                    </Fragment>
                                    : id === 11 ?
                                      <Fragment>
                                        <MenuHamburguesaDireccion cerrarSesionModal={cerrarSesionModal}
                                          agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()}
                                          idUsuario={id} />
                                        <Route path="/TablaClientesComponentDG" component={TablaClientesComponentDG} />
                                        <Route path="/DetalleClienteComponentDG" component={DetalleClienteComponentDG} />   
                                        <Route path="/PanelConsultaHologramasDGComponent" component={PanelConsultaHologramasDGComponent} exact />                                                                                                          
                                        <Route path="/SolicitudesACDireccion" component={SolicitudesACDireccion} exact />               
                                        <Route path="/TabsOCNacionalDGComponent" component={TabsOCNacionalDGComponent} exact /> 
                                        <Route path="/InformacionClienteComponent" component={InformacionClienteComponent} exact />                                                                                           
                                        <Route path="/TabsUIDGComponent" component={TabsUIDGComponent} exact />                                                                                           
                                        <Switch>
                                          
                                        </Switch>
                                      </Fragment>
                                      : id === 12 ?
                                        <Fragment>
                                          <MenuHamburguesaExportacion cerrarSesionModal={cerrarSesionModal}
                                            agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()}
                                            idUsuario={id} />
                                          <Switch>
                                            <Route path="/UsuariosOCExportacionComponent" component={UsuariosOCExportacionComponent} exact />
                                            <Route path="/ModuloConsultaOCComponent" component={TablaClientesComponentOC} exact />
                                            <Route path="/ConsultaDetalleOCComponent" component={DetalleClienteComponent} exact />
                                            <Route path="/TabsSolicitudesACExportacionComponent" component={TabsSolicitudesACExportacionComponent} exact />
                                            <Route path="/SolicitudesRecibidasOCExportacion" component={SolicitudesRecibidasComponent} exact />
                                            <Route path="/SolicitudesRevisionOCExportacion" component={SolicitudesRevisionOCExportacion} exact />
                                            <Route path="/SeguimientoExportacion" component={SeguimientoExportacionComponent} exact />
                                            <Route path="/InformacionFC09_OC" component={InformacionFC09_OCComponent} exact />
                                          </Switch>
                                        </Fragment>
                                          :id === 13?
                                          (
                                            <Fragment>
                                              <MenuHamburguesaInspeccion cerrarSesionModal={cerrarSesionModal} agregarClasesToggle={agregarClasesToggle} componenteCerrarSesionModal={modalComponent()} idUsuario={id} />
                                              <Switch>
                                                <Route path="/PanelSolicitudes" component={PanelSolicitudes} exact />
                                              </Switch>
                                            </Fragment>
                                          )
                                          :
                                        <Fragment>
                                          <Switch>
                                            <Route path="/perfil_usuario" component={PerfilUsuario} />
                                          </Switch>
                                        </Fragment>

                }
              </Fragment>

              <br></br> <br></br>
              <div className='text-center'>
                <p>© {new Date().getFullYear()} COMERCAM. Todos los derechos reservados. Declaración de <a href="https://comercam-dom.org.mx/"><span>Privacidad</span></a></p>
              </div>



            </div>


          ) :
            (
              <div className="text-center">

                <Login />
              </div>
            )
        }
      </Router>
    </Fragment>
  )
}



export default App;
